import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

const WHAT_TO_DO_FOR_CODES = {
  PARSE_FAILED:       "Try re-exporting as a standards-compliant SVG.",
  SHAPE_STROKES:      "Remove or expand any strokes.",
  LOTS_OF_POINTS:     "Try simplifying your object by removing points or merging objects together.",
  OVERLAPPING_POINTS: "Look through your layers for objects sitting underneath other objects and remove them if they are not needed.",
  SKETCH_FORMAT:      "Export the file as SVG.",
  INKSCAPE_FORMAT:    "Export the file as SVG.",
  LOW_PRECISION:      "Resize your artboard to a height of 1008 and resize your icon to fit inside the larger area.",
  INVISIBLE_OBJECTS:  "Remove any objects that are not part of your icon.",
  EVERYTHING_HIDDEN:  "Check the file and try exporting a new SVG. You may need to create a brand new document in your editor and start from scratch.",
  CONTAINS_IMAGES:    "Remove any images because they cannot be converted into icons.",
  MISSING_VIEWBOX:    "Make sure your SVG has a \"viewBox\", which the spec requires. Try exporting a new SVG, maybe?",
  IS_SVG_FONT:        "Get the original icons from this SVG Font and use those instead.",
  EXCEEDS_VIEWBOX:    "Double-check that you intend to have objects outside the artboard.",
  CONTAINS_TEXT:      "Convert text objects that use fonts to outlines.",
};

const SvgInspection = createReactClass({
  propTypes: {
    results: PropTypes.object.isRequired,
    onContinueAnyway: PropTypes.func.isRequired,
  },

  resultsToString() {
    const {results} = this.props;
    const {errors, warnings} = results.messages;
    const messagesToString = (messages) => [...messages].map((message) => message.desc).join(', ');
    const errorsAsString = (errors.length > 0) ? `errors: ${messagesToString(errors)}` : '';
    const warningsAsString = (warnings.length > 0) ? `warnings: ${messagesToString(warnings)}` : '';

    return `status: ${results.stoplight}; ${errorsAsString}${warningsAsString}`;
  },

  renderHelpScoutSupport(type) {
    const prompt = <span>Help! I don&apos;t understand this. Let me talk to a <strike>Jedi</strike> human!</span>;

    return <a href="mailto:help@fortawesome.com" className={`text-${type}`}>{prompt}</a>;
  },

  renderMessages(messages) {
    return [...messages].map((message, index) => {
      return (
        <li key={index}>
          {message.desc}
          <strong> How you can fix this: </strong>
          {WHAT_TO_DO_FOR_CODES[message.code]}
        </li>
      );
    });
  },

  renderErrors() {
    return (
      <div className="alert alert-danger bg-body has-icon">
        <i className="ficon ficon-warning ficon-lg alert-icon"></i>
        <div className="row m-xs-y-sm">
          <div className="col-xs-7 col-xs-offset-1 p-xs-x-0 text-xs-center"><h3>The dark side this SVG is.<br/>Fix it you must.</h3></div>
          <div className="col-xs-4"><i className="ficon ficon-yoda ficon-4x text-muted"></i></div>
        </div>

        <ul className="p-xs-l-md">
          {this.renderMessages(this.props.results.messages.errors)}
        </ul>

        <div className="text-sm-center">
          {this.renderHelpScoutSupport('danger')}
        </div>
      </div>
    );
  },

  renderWarnings() {
    return (
      <div className="alert alert-info bg-body has-icon">
        <i className="ficon ficon-exclamation-circle ficon-lg alert-icon"></i>
        <div className="row m-xs-y-sm">
          <div className="col-xs-7 col-xs-offset-1 D-xs-x-0 text-xs-center"><h3>The path to the dark side this SVG may be.</h3></div>
          <div className="col-xs-4"><i className="ficon ficon-yoda ficon-4x text-muted"></i></div>
        </div>

        <ul className="p-xs-l-md m-xs-b-md">
          {this.renderMessages(this.props.results.messages.warnings)}
        </ul>

        <div className="text-xs-center">
          <button className="btn btn-info btn-lg m-xs-b-sm" onClick={this.props.onContinueAnyway}>That&apos;s okay, upload it anyway!</button>
        </div>

        <div className="text-sm-center">
          {this.renderHelpScoutSupport('info')}
        </div>
      </div>
    );
  },

  render() {
    return (this.props.results.stoplight === "red") ? this.renderErrors() : this.renderWarnings();
  },
});

export default SvgInspection;



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/SvgInspection.js